import Service			from "../../Libs/Service";
import _				from "lodash";

import { Creative }		from "./Creative";
import { Layout } 		from "./Layout";
import Broadcast        from "../../Libs/Broadcast";

let Tracking = new Service({

	Name: "Tracking",

	Events: {

	},

	Actions: {
		'NativeTrackingAvailabilityStatus': function(data) {
			Broadcast.call('Tracking Availability Status Changed', [data]);
		}
    },

    init() {
    },

    async getAvailability() {
    }
});

window.Tracking = Tracking;

export { Tracking }

